import WsService from "services/WsService";
import Credential from "domain/admin/Credential";
import RawWsService from "../RawWsService";

const ENDPOINT_BASE = "/admin/credential";

export default class CredentialService {

  static searchPaginatedCredential(search, headers) {

    let endpoint = ENDPOINT_BASE + "?search=" + search;

    return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
      response => {
        let results = [];
        response.body.forEach(jsonCredential => {
            results.push(new Credential(jsonCredential));
          }
        );
        return {"headers": response.headers, "body": results};
      },
      response => {
        return [];
      });
  }

  static retrieveCredential(credentialId) {

    let endpoint = ENDPOINT_BASE + "/" + credentialId;

    return WsService.get(endpoint, {}, 200).then(
      response => {
        return new Credential(response);
      },
      response => {
        return response;
      });
  }

  static createCredential(credential) {

    let endpoint = ENDPOINT_BASE;
    let jsonObj = Credential.toJson(credential);
    return WsService.post(endpoint, jsonObj, 201).then(
      response => {
        return new Credential(response);
      },
      response => {
        return response;
      });
  }

  static updateCredential(credential) {

    let endpoint = ENDPOINT_BASE + "/" + credential.id;
    let jsonObj = Credential.toJson(credential);

    return WsService.put(endpoint, jsonObj, 200).then(
      response => {
        return new Credential(response);
      },
      response => {
        return response;
      });
  }

  static changePassword(username, oldPassword, newPassword) {
    let endpoint = ENDPOINT_BASE + "/change-password";

    let jsonObj = {};
    jsonObj["username"] = username;
    jsonObj["old-password"] = oldPassword;
    jsonObj["new-password"] = newPassword;

    return WsService.put(endpoint, jsonObj, 200).then(
      response => {
        return "success";
      },
      response => {
        return response;
      });
  }

  static getCredentialWithOutPasswordByRegistrationId(registrationId) {
    let endpoint = ENDPOINT_BASE + "?registration-id=" + registrationId;
    return WsService.get(endpoint, {}, 200).then(
      response => {
        return new Credential(response);
      },
      response => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/admin/CredentialService.js